import React from 'react';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import { Table, Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import 'babel-polyfill';
import {
	Accordion,
	AccordionItem,
	AccordionItemTitle,
	AccordionItemBody,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import similarType from './similar.json';
import LoggedInPage from '../../views/core/LoggedInPage';
import HmAjax from '../../util/HmAjax';
import $ from 'jquery';

import CustomAccordian from "./CustomAccordian";


var defaultFontColor = "&color=%23000000";
var defaultFontName = "&fontFamily=Muli-Light";
var defaultFontSize = "&fontSize=13";

export default class WebQuestionView extends LoggedInPage {
	constructor(props) {
		super(props);
		//this.handleChange = this.handleChange.bind(this);
		this.likeFn = this.likeFn.bind(this);
		this.filterHTML = this.filterHTML.bind(this);
		this.checkImageLoaded = this.checkImageLoaded.bind(this);
		
		try{
		this.WIRIS_URL = this.getUrlFor("WIRIS_URL");
		this.imageServiceUrl = this.WIRIS_URL + "/formula3/render?transparency=true";
		}catch(e){
			if(console)
				console.log("Error occurred in mathmlToimage | ",e);
		}
	}


	likeFn(event) {
		if($(event.currentTarget).hasClass("selected")){
		   return false;
	    }
		
		 var postParams = {
			trackingDefId: 2,
			testId : this.props.qdata.testId,
			questionId : this.props.qdata.testQuestionId,
			snippetId : this.props.qdata.snippetId,
			rating : parseInt($(event.currentTarget).attr("data-id")), 
			currQuestAtt : this.props.qdata.attemptNo,
			sourceId : 2,
			action : "submit"
		}
		var currentRating = parseInt($(event.currentTarget).attr("data-id"));
		var me = this;
		var currentTarget = $(event.currentTarget);
		var callBackSuccess = function(response){
			//$(".likebox").attr("data-myrating",currentRating);
			$("#"+me.props.qdata.testQuestionId+"-"+me.props.qdata.attemptNo).attr("data-myrating",currentRating);
			$("#"+me.props.qdata.testQuestionId+"-"+me.props.qdata.attemptNo).find(".ratingIcon").removeClass("selected");
			$(currentTarget).addClass("selected");
		}

		var callBackFailure = function(error){
			console.log("Error in Scorecard TRACK_SOLUTION");
		}

		new HmAjax(this.getUrlFor("TRACK_SOLUTION"),postParams).post(callBackSuccess,callBackFailure);
		
		try{
			var trackObj = {
				"test_id": this.props.qdata.testId,
			    "snippet_id": this.props.qdata.snippetId,
			    "question_source":this.props.qdata.source,
			    "attempt_no": this.props.qdata.attemptNo,
			    "helpful": parseInt($(event.currentTarget).attr("data-id")) === 2,
			    "source":this.getTracker().enums.itemRatedSource.scorecard
			}
			this.initiateTrack("solution_rated",trackObj);
		}catch(e){
		}
	}


	renderOptions() {		
		if (this.props.qdata.questionType === "mcq") {
			return (
				<div name="optionsVw">
					{/* Options: */}
					<ul className="qoption">
						{this.props.qdata.optionText.map(function (option, index) {
							return <li key={index}>{ReactHtmlParser(option)}</li>;
						})}

					</ul>
				</div>
			)
		} else {
			return (
				<div> </div>)
		}		
	}
	setRatingSelected(id){
	   /*if(currentRating != null){
		   if(currentRating == id){
			   return "selected";
		   }
	   }*/
	   if(this.props.existingRatingObj.hasOwnProperty(this.props.qdata.testQuestionId+"-"+this.props.qdata.attemptNo)){
		   //console.log(this.props.existingRatingObj[this.props.qdata.testQuestionId+"-"+this.props.qdata.attemptNo].rate, id);
		   if(this.props.existingRatingObj[this.props.qdata.testQuestionId+"-"+this.props.qdata.attemptNo].rate == parseInt(id)){
			   return "selected";
		   }
	   }
   }
	renderlikebtn() {		
		return (
			<div className="scorecardLikebox" id={this.props.qdata.testQuestionId+"-"+this.props.qdata.attemptNo} data-myrating="0">
				<div className="inlineblock">{this.rb("rating.title")}</div>
				<div className="btngp inlineblock">
					<span className={"ratingIcon "+this.setRatingSelected(2)} data-id="2" onClick={this.likeFn.bind(this)}><i className="material-icons">thumb_up</i></span>
					<span className={"ratingIcon "+this.setRatingSelected(1)} data-id="1" onClick={this.likeFn.bind(this)}><i className="material-icons">thumb_down</i></span>
				</div>
			</div>
		)
	}
	filterHTML(html) {
		if(html !== null){
	        var sb="";
	        var pos = 0;
	        var start;        
	        while ((start = html.indexOf("<math", pos)) != -1) {
	            sb+=(html.substring(pos, start));
	            var autoclose = html.indexOf("/>", start);
	            var greaterindex = html.indexOf(">", start);
	            if (autoclose != -1 && autoclose < greaterindex) { //autoclosed math tag
	                pos = autoclose + "/>".length();
	            } else {
	                pos = html.indexOf("</math>", start) + "</math>".length;
	                var formula = html.substring(start, pos);
	                var url = this.getImageUrl(formula);
	                var img = "<img src=\""+url+ "\" align='middle' class='formula' />";
	                sb+=img;
	            }
	        }
	        sb+=(html.substring(pos));
	        return sb.toString();
		}
    }

	renderResultFn() {		
		if(this.props.qdata && (!this.props.qdata.attemptNo || this.props.qdata.attemptNo === 0)){
			return (
				<span className="unans">{this.rb("scorecard.notattempted")}</span>
			)
		}
		else if (this.props.qdata.optionResult && this.props.qdata.optionResult.length > 0) {
			if (this.props.qdata.optionResult[0].optionCorrect === true) {

				return (
					<span><i className="material-icons corrans">done</i></span>
				)
			} else if (this.props.qdata.optionResult[0].optionCorrect === false && this.props.qdata.optionResult[0].userAns !== null) {
				return (
					<span><i className="material-icons wrgans">close</i></span>
				)
			} else {
				return (
					<span className="unans">{this.rb("scorecard.notattempted")}</span>
				)
			}
		}
		else {
			return (
				<span className="unans">{this.rb("scorecard.notattempted")}</span>
			)
		}
	}

	rendersubbtns() {
		var me = this;
		//console.log(this.props.qdata);
		if (this.props.qdata.similarType && this.props.qdata.similarType.length > 0) {
			return (
				<div>
					{this.props.qdata.similarType.map((similarType, index) =>
						<CustomAccordian similarType={similarType} key={index} ga={me.props.ga} snippetId={me.props.qdata.snippetId} source={me.props.qdata.source}  testQuestionId={me.props.qdata.testQuestionId} testId={me.props.qdata.testId} topicSubTopicMapId={me.props.qdata.topicSubTopicMapId} callbackParent={this.props.callbackParent} accessId={this.props.accessId} classId={this.props.classId} recomLocked={this.props.recomLocked} />
					)}

				</div>
			)
		}

	}
	getQuestionNumber(){
		var qNo = 0;
		if(this.props.qno){
			qNo = this.props.qno;
		}

		if(this.props.qdata.testMode === "TEST"){
			return this.rb("questionview.q-label").replace("{1}",this.props.qno);
		}

		return this.rb("questionview.q-label.withattempt").replace("{1}",this.props.qno).replace("{2}",this.props.qdata.attemptNo);
	}

	getImageUrl(mathml, fontColor, fontSize, fontName) {
	    var fontOptions = "";
	    if(fontColor != null && fontColor != undefined) {
	        fontOptions += "&color=%23" + fontColor;
	    } else {
	        fontOptions += defaultFontColor;
	    }
	    if(fontSize != null && fontSize != undefined) {
	        fontOptions += "&fontSize=" + fontSize;
	    } else {
	        fontOptions += defaultFontSize;
	    }
	    if(fontName != null && fontName != undefined) {
	        fontOptions += "&fontFamily=" + fontName;
	    } else {
	        fontOptions += defaultFontName;
	    }
	    // replace hack to remove <br> tag from mathml input to wiris editor service since latest versions 
	    // throws error for invalid inputs, which was previously rendered by older editor versions.
	    mathml = mathml.trim().replace("</math><br>","</math>");
	    var returnImage = this.imageServiceUrl + "&mml=" + encodeURIComponent(this.escapeUTF8Chars(mathml)) + fontOptions;
	    return returnImage;
	}
	
	escapeUTF8Chars(str) {
	    var out = "";
	    for(var i = 0; i < str.length; i++){
	        var c = str.charCodeAt(i);
	        if(c < 128) {
	            out += str.charAt(i);
	        } else {
	            out += "&#" + c + ";";
	        }
	    }
	    return out.trim();
	}
	checkImageLoaded(){	
		try{
			$('img').unbind("error");
			$('img').error(function(){		
				var me = this;
				var timeDelay = 5000;
				
				if(!$(me).attr('imageReloadCount')){
					$(me).attr('imageReloadCount',1);
				}
				
				timeDelay = timeDelay * parseInt($(me).attr('imageReloadCount'));			
				
				setTimeout(function()
				{ 				
					if(!$(me).attr('imageReloadCount')){
						$(me).attr('imageReloadCount',1);
					}else{
						$(me).attr('imageReloadCount',parseInt($(me).attr('imageReloadCount'))+1);
					}
					
					if($(me).attr('imageReloadCount')<=4){
						//console.log("timeDelay::",timeDelay);
						$(me).attr('src',$(me).attr('src'));
					}
					
					if(console){
						console.log("image not loaded :"+$(me).attr('src'));			
					}
				
				}, timeDelay);		
				
			}).load(function(){
				//console.log("loaded successfully...");
			});
		}
		catch(e){
			
		}
		
	}

	componentDidMount() {
		this.checkImageLoaded();
	}
	
	render() {
		var me = this;
		return (
			<div name="questionView" className="qvroot">
				<div className="qView scrollEqn">
					{/* <div className="quesorder">{"Q" + (this.props.qno + 1) + "."}</div> */}
					<div className="qvwList">
						<div className="quesorder">{this.getQuestionNumber()}
							<div className="qVw">
							<div name="questionVw scro">
								<div>
									{ReactHtmlParser(this.props.qdata.questionText)}
								</div>
							</div>

							{this.renderOptions()}

							<div name="userAnswerVw" className="anspadd">
								<span>{this.rb("scorecard.your_answer")}:</span>
								{this.renderResultFn()}
								{this.props.qdata.optionResult.map(function (optionObj, index) {
									if(me.props.qdata.attemptNo > 0){
										if(optionObj.unitPosition == 0){
											return <span className="mathml" key={index}>{ReactHtmlParser(optionObj.label)} {ReactHtmlParser(optionObj.unit)} {ReactHtmlParser(me.filterHTML(optionObj.userAns))}</span>;
										}
										return <span className="mathml" key={index}>{ReactHtmlParser(optionObj.label)} {ReactHtmlParser(me.filterHTML(optionObj.userAns))} {ReactHtmlParser(optionObj.unit)}</span>;
									}else{
										return <span className="mathml" key={index}>{ReactHtmlParser(me.filterHTML(optionObj.userAns))}</span>;
									}
								})}
							</div>

							<div name="correctAnswerVw" className="anspadd">
								<span>{this.rb("scorecard.correct_answer")}:</span>
								{this.props.qdata.optionResult.map(function (optionObj, index) {
									if(me.props.qdata.attemptNo > 0){
										if(optionObj.unitPosition == 0){
											return <span className="mathml" key={index}>{ReactHtmlParser(optionObj.label)} {ReactHtmlParser(optionObj.unit)} {ReactHtmlParser(me.filterHTML(optionObj.correctAns))}</span>;
										}
										return <span className="mathml" key={index}>{ReactHtmlParser(optionObj.label)} {ReactHtmlParser(me.filterHTML(optionObj.correctAns))} {ReactHtmlParser(optionObj.unit)}</span>;
									}else{
										return <span className="mathml" key={index}>{ReactHtmlParser(me.filterHTML(optionObj.correctAns))}</span>;
									}
								})}
							</div>
							</div>

						</div>



					</div>
				</div>

				<div name="solutionVw">
					<div className="qsoln scrollEqn">
						
						<p>{this.rb("editor.solutionTitle")}:</p>
						{ReactHtmlParser(this.props.qdata.solutionText)}
						{this.renderlikebtn()}
					</div>
				</div>
				
				{this.rendersubbtns()}
			</div>

		);
	}
} 


// WEBPACK FOOTER //
// ./src/components/question/WebQuestionView.js